import React from 'react';

const NavHomeIconFill = ({ size = '24', fill = '#ffffff' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 20.5V9.25004L12 3.60583L19.5 9.25004V20.5H13.9038V13.8077H10.0961V20.5H4.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default NavHomeIconFill;
